import { useMemo, useCallback } from 'react'

import { Box } from '@material-ui/core'
import { ErrorBoundary } from '@scoir/error-reporter'
import { Selectors } from '@scoir/college-search'

import ToggleableSection from 'components/ToggleableSection'
import tagService from 'common/tags-service'
import { getSegmentValue } from './segment-service'
import { withContext } from './Context'

export const SegmentName = 'Interests'
export const Criteria = 'OneOf'

const { API_CALL_NAMES, StudentLifeSelector, SelectorContextProvider } = Selectors

interface IInterestsSegmentSelectorProps {
  segment: any
  onChange: (criteria: string, segmentName: string, value: string[]) => void
}

export const InterestsSegmentSelector = ({ segment, onChange }: IInterestsSegmentSelectorProps) => {
  const currentValue = useMemo(() => getSegmentValue(segment, Criteria, SegmentName), [segment])

  const onSelect = useCallback(
    (data) => {
      const newVal = data.Tags || []
      onChange(Criteria, SegmentName, newVal)
    },
    [onChange],
  )

  return (
    <ToggleableSection
      title="Student Life"
      info="Clubs, activities, and campus life"
    >
      <Box
        mt={1}
        position="relative"
        zIndex={2}
      >
        <ErrorBoundary>
          <SelectorContextProvider
            apiCalls={{
              [API_CALL_NAMES.onTagsSearch]: tagService.fetchMediaByTerm,
              [API_CALL_NAMES.onAllTagsSearch]: tagService.getAllTags,
            }}
            data={{ Tags: currentValue }}
            onUpdateData={onSelect}
          >
            <StudentLifeSelector />
          </SelectorContextProvider>
        </ErrorBoundary>
      </Box>
    </ToggleableSection>
  )
}

const InterestsSegmentSelectorWithContext = withContext(InterestsSegmentSelector)

export default InterestsSegmentSelectorWithContext
